export default function RootedInCommunity() {
  return (
    <section className="py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative h-[460px] w-full rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/e56934b24210aa1f26f80f9d21b7146e.jpg"
                alt="Rooted in the Sugar Hill community"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent" />
            </div>
            <div className="absolute -bottom-5 -right-5 bg-white rounded-2xl px-6 py-4 border border-stone-100 max-w-[200px]">
              <p className="text-xs text-stone-500 font-medium mb-0.5">Based in</p>
              <p className="text-sm font-extrabold text-gray-900 leading-snug">Sugar Hill, GA</p>
              <p className="text-xs text-stone-400 mt-1">Serving Gwinnett &amp; surrounding areas</p>
            </div>
          </div>

          {/* Text */}
          <div className="order-1 lg:order-2">
            <span className="text-xs font-bold tracking-widest uppercase text-pink-500 mb-4 block">
              Community First
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              Rooted in This<br />Community
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-5">
              This wasn&apos;t built from the outside looking in. I live here, I&apos;m raising my son here, and I help families plant roots here every day.
            </p>
            <p className="text-base text-gray-500 leading-relaxed mb-10">
              If you&apos;re thinking about moving into or out of the area, I&apos;m here to help.
            </p>

            <a
              href="mailto:hello@themommymingle.com"
              className="inline-flex items-center gap-2.5 px-7 py-4 bg-gray-900 text-white rounded-full text-sm font-bold hover:bg-gray-700 transition-all cursor-pointer whitespace-nowrap"
            >
              Start the conversation
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
